import { RolesService } from '../config/service';
import { logout, refreshLogin } from 'constructor/lib/module/auth/duck';
import { store } from '../store/create';
import { CACHE_NAME, CACHE_NAME_OUTER } from '../constants/common';
import axios from 'axios';
import qs from 'qs';

//const CACHE_NAME = process.env.REACT_APP_AUTH_CACHE_NAME
const refreshLoginAction = (rToken) => store.dispatch(refreshLogin(rToken))
const logoutAction = () => store.dispatch(logout())

// Функции для получения токенов (читаем каждый раз свежие)
const getRefreshToken = () => {
  const cache = localStorage.getItem(CACHE_NAME);
  return cache ? JSON.parse(cache).refresh_token : null;
};

const getRefreshTokenOuter = () => {
  const cache = localStorage.getItem(CACHE_NAME_OUTER);
  return cache ? JSON.parse(cache).refresh_token : null;
};

// Логи для отладки конфигурации
console.log('🔍 Auth Config Debug:', {
  CACHE_NAME,
  CACHE_NAME_OUTER,
  REACT_APP_AUTH_BASE_URL_IRTECH: process.env.REACT_APP_AUTH_BASE_URL_IRTECH,
  hasRefreshToken: !!getRefreshToken(),
  hasRefreshTokenOuter: !!getRefreshTokenOuter(),
  localStorageKeys: Object.keys(localStorage).filter(key => key.includes('auth') || key.includes('token'))
});

// Создаем экземпляр axios для внешнего API
const instanceOuter = axios.create({
  baseURL: process.env.REACT_APP_AUTH_BASE_URL_IRTECH,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Функция для обновления внешнего токена
export const refreshLoginOuter = async (refresh_token) => {
  console.log('🔍 RefreshLoginOuter: Starting outer token refresh', {
    hasRefreshToken: !!refresh_token,
    refreshTokenLength: refresh_token ? refresh_token.length : 0,
    baseURL: process.env.REACT_APP_AUTH_BASE_URL_IRTECH
  });
  
    try {
      console.log('🔍 RefreshLoginOuter: Making request to outer API...');
      const response = await instanceOuter.post('', {
        grant_type: 'refresh_token',
        refresh_token: refresh_token
      });
    
    console.log('🔍 RefreshLoginOuter: Received response', {
      status: response.status,
      hasData: !!response.data,
      hasAccessToken: !!(response.data && response.data.access_token),
      hasRefreshToken: !!(response.data && response.data.refresh_token)
    });
    
    // Сохраняем обновленные токены в localStorage
    if (response.data) {
      localStorage.setItem(CACHE_NAME_OUTER, JSON.stringify(response.data));
      console.log('🔍 RefreshLoginOuter: Tokens saved to localStorage', {
        cacheKey: CACHE_NAME_OUTER,
        dataKeys: Object.keys(response.data)
      });
    }
    
    return response.data;
  } catch (error) {
    console.error('🔍 RefreshLoginOuter: Failed to refresh outer token:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      config: {
        url: error.config?.url,
        baseURL: error.config?.baseURL
      }
    });
    throw error;
  }
};

export const errorHandler = async (error, instance) => {
 const originalConfig = error.config;

    if (error.response) {
      console.log('🔍 ErrorHandler: Received error response', {
        status: error.response.status,
        url: originalConfig.url,
        headers: originalConfig.headers
      });

      if (originalConfig.url.includes('token') &&
        error.response.data['error_description'] === 'Session not active') {
        console.log('🔍 ErrorHandler: Session not active, logging out');
        await logoutAction()
      }
      // Access Token was expired
      if (error.response.status === 401 && !originalConfig._retry) {
        console.log('🔍 ErrorHandler: 401 error detected, starting token refresh process');
        originalConfig._retry = true;
        try {
          // Check if x-access-token header exists and is valid
          const xAccessToken = originalConfig.headers['x-access-token'];
          const hasValidXAccessToken = xAccessToken && xAccessToken !== '' && xAccessToken !== 'null' && xAccessToken !== 'undefined';
          
          // Получаем свежие токены
          const refreshToken = getRefreshToken();
          const refreshTokenOuter = getRefreshTokenOuter();
          
          console.log('🔍 ErrorHandler: Token validation', {
            xAccessToken: xAccessToken,
            hasValidXAccessToken: hasValidXAccessToken,
            refreshToken: refreshToken,
            refreshTokenOuter: refreshTokenOuter
          });
          
          // Дополнительная отладка localStorage
          console.log('🔍 ErrorHandler: localStorage debug', {
            CACHE_NAME,
            CACHE_NAME_OUTER,
            internalCache: localStorage.getItem(CACHE_NAME),
            outerCache: localStorage.getItem(CACHE_NAME_OUTER),
            allKeys: Object.keys(localStorage)
          });
          
          // Refresh internal token
          console.log('🔍 ErrorHandler: Refreshing internal token...');
          refreshToken ? await refreshLoginAction(refreshToken) : await logoutAction()
          console.log('🔍 ErrorHandler: Internal token refresh completed');

          // If x-access-token was present, also refresh outer token
          if (hasValidXAccessToken && refreshTokenOuter) {
            console.log('🔍 ErrorHandler: Refreshing outer token...');
            try {
              await refreshLoginOuter(refreshTokenOuter);
              console.log('🔍 ErrorHandler: Outer token refresh completed successfully');
            } catch (outerError) {
              console.warn('🔍 ErrorHandler: Failed to refresh outer token:', outerError);
            }
          } else {
            console.log('🔍 ErrorHandler: Skipping outer token refresh', {
              hasValidXAccessToken,
              hasRefreshTokenOuter: !!refreshTokenOuter
            });
          }

          const token = localStorage.getItem(CACHE_NAME) && JSON.parse(localStorage.getItem(CACHE_NAME)).access_token
          const outerToken = localStorage.getItem(CACHE_NAME_OUTER) && JSON.parse(localStorage.getItem(CACHE_NAME_OUTER)).access_token
          
          console.log('🔍 ErrorHandler: Updated tokens', {
            hasInternalToken: !!token,
            hasOuterToken: !!outerToken,
            tokenLength: token ? token.length : 0,
            outerTokenLength: outerToken ? outerToken.length : 0
          });
          
          originalConfig.headers.Authorization = token ? `Bearer ${token}` : ''
          if (hasValidXAccessToken && outerToken) {
            originalConfig.headers['x-access-token'] = outerToken;
            console.log('🔍 ErrorHandler: Added x-access-token to headers');
          }
          
          console.log('🔍 ErrorHandler: Retrying request with updated headers', {
            url: originalConfig.url,
            hasAuth: !!originalConfig.headers.Authorization,
            hasXAccessToken: !!originalConfig.headers['x-access-token']
          });
          
          return instance(originalConfig);
        } catch (_error) {
          console.error('🔍 ErrorHandler: Token refresh failed:', _error);
          return Promise.reject(_error);
        }
      }
    }
    return Promise.reject(error);
}

export async function setInitData(data, setUserData) {
    const { auth, authActions } = data;
    const { user } = auth.data;
    const { user_role, org_id, series, sections } = data;
    if (authActions.login.length == 1 && user) { // if user logged in
        if (!localStorage.getItem('orgID') || !localStorage.getItem('roleUser') || !localStorage.getItem('userId')) {
            setStorageData(user);
            setUserData(getUserPayload(user))
            if (user.role_field === "staff") {
                const roles = await RolesService.getItem({ id: user.access })
                setStorageData(roles);
                setUserData(getUserPayload({ ...user, ...roles }));
            }
        }
        else if ((localStorage.getItem('orgID') &&
                localStorage.getItem('roleUser') &&
                localStorage.getItem('userId')) &&
                (!user_role || !org_id) ) {
                    setUserData(getUserPayload(user));
                    if (user.role_field === 'staff' && (!sections.length || !series.length)) {
                        const roles = localStorage.getItem('sections') && localStorage.getItem('series')
                        ? { sections: localStorage.getItem('sections'), series: localStorage.getItem('series') }
                        : await RolesService.getItem({ id: user.access })

                        setStorageData(roles);
                        setUserData(getUserPayload({ ...user, ...roles }));
                    }
                }
    } else if (!localStorage.getItem(CACHE_NAME)) {
        clearStorage();
    }
}

function clearStorage() {
    localStorage.removeItem("roleUser");
    localStorage.removeItem("orgID");
    localStorage.removeItem("userId");
    localStorage.removeItem('accountTitle');
    localStorage.removeItem('emailSspro');
    localStorage.removeItem('emailDou');
    localStorage.removeItem('avatarId');
   // localStorage.clear();
};
function setLSbyKey(value, key) {
    switch (key) {
        case 'org_id':
            return localStorage.setItem('orgID', value);
        case 'role_field':
            return localStorage.setItem('roleUser', value);
        case 'sub':
            return localStorage.setItem('userId', value);
        case 'series':
            return localStorage.setItem('series', value);
        case 'sections':
            return localStorage.setItem('sections', value);
    }
};
function setStorageData(data) {
    const dataKeys = Object.keys(data);
    dataKeys.forEach(key => setLSbyKey(data[key], key));
};
function getUserPayload(data) {
    const payload = {};
    const dataKeys = Object.keys(data);
    dataKeys.forEach(key => {
        switch (key) {
            case 'org_id':
                return payload['org_id'] = data[key];
            case 'role_field':
                return payload['user_role'] = data[key];
            case 'sub':
                return payload['user_id'] = data[key];
            case 'series':
                return payload['series'] = JSON.parse(data[key]);
            case 'sections':
                return payload['sections'] = JSON.parse(data[key]);
        }
    });
    return payload;
}
